// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA0zhNFK2oDz3XWQf-xly8AMFeRvXKM1Tg",
  authDomain: "soroushcrm.firebaseapp.com",
  projectId: "soroushcrm",
  storageBucket: "soroushcrm.firebasestorage.app",
  messagingSenderId: "876836218546",
  appId: "1:876836218546:web:f51889befa242d3f67cbab"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging };
